import { Component, Input } from '@angular/core';
import { MockTeam, teamMembersLabel } from './team-action-mock.data';

// Maquette d'estimation « action d'équipe » : repère d'une équipe, membres en infobulle.
@Component({
  selector: 'team-action-mock-team',
  template: `<span
    class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 caption leading-none bg-primary-light text-primary whitespace-nowrap"
    [matTooltip]="membersLabel"
    ><mat-icon style="font-size: 14px; width: 14px; height: 14px; line-height: 14px">groups</mat-icon>Équipe</span
  >`,
})
export class TeamActionMockTeamBadgeComponent {
  @Input() set team(value: MockTeam) {
    this.membersLabel = teamMembersLabel(value);
  }

  membersLabel = '';
}
